module.exports = __webpack_public_path__ + "static/media/Plasscoin.0c822385.svg";